export default __webpack_public_path__ + "38c0934.png";